import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxOfferMilleniumIcon: React.FC<IconSvgProps> = (props) => (
  <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="4.80357"
      y="7.05601"
      width="14.3929"
      height="14.3929"
      rx="1.625"
      stroke={props.color}
      strokeWidth="1.39286"
    />
    <path
      d="M15.5908 2.35547C16.3615 2.35547 16.9863 2.98028 16.9863 3.75098V4.35938C16.9863 4.90593 16.6672 5.40211 16.1699 5.62891L13.2324 6.96777C12.4602 7.31971 11.6849 6.48525 12.0928 5.74121L13.5527 3.08008C13.7978 2.63338 14.2669 2.35547 14.7764 2.35547H15.5908Z"
      stroke={props.color}
      strokeWidth="1.39286"
    />
    <path
      d="M8.40918 2.35547C7.63848 2.35547 7.01367 2.98028 7.01367 3.75098V4.35938C7.0137 4.90593 7.33282 5.40211 7.83008 5.62891L10.7676 6.96777C11.5398 7.31971 12.3151 6.48525 11.9072 5.74121L10.4473 3.08008C10.2022 2.63338 9.73312 2.35547 9.22363 2.35547H8.40918Z"
      stroke={props.color}
      strokeWidth="1.39286"
    />
    <path d="M12 21.6874V7.47705" stroke={props.color} strokeWidth="1.39286" />
  </svg>
)
